module.exports = __webpack_public_path__ + "img/company1_1.e95e9a41.png";